import { createContext } from 'react'
import Product from 'store/entities/Product/Product.store'

export interface StoryTileCTAContextValue {
  onProductClick: (product: Product) => void
}

const StoryTileCTAContext = createContext<StoryTileCTAContextValue | undefined>(
  undefined,
)

export default StoryTileCTAContext
